import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { IconComponent } from '../icon/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-pagination',
  imports: [IconComponent],
  styleUrl: './pagination.scss',
  templateUrl: './pagination.html',
})
export class PaginationComponent {
  /** Page courante (1-based). */
  readonly page = input(1);

  /** Nombre total d'éléments. */
  readonly totalItems = input(0);

  /** Nombre d'éléments par page. */
  readonly pageSize = input(10);

  /** Nombre maximal de pages affichées dans la fenêtre. */
  readonly windowSize = input(5);

  /** Émis avec le numéro de page demandé (1-based). */
  readonly pageChange = output<number>();

  protected readonly totalPages = computed(() =>
    Math.max(1, Math.ceil(this.totalItems() / this.pageSize())),
  );

  protected readonly pages = computed(() => {
    const total = this.totalPages();
    const current = Math.min(Math.max(1, this.page()), total);
    const size = this.windowSize();
    let start = Math.max(1, current - Math.floor(size / 2));
    const end = Math.min(total, start + size - 1);
    start = Math.max(1, end - size + 1);
    const result: number[] = [];
    for (let p = start; p <= end; p += 1) {
      result.push(p);
    }
    return result;
  });

  protected readonly hasPrevious = computed(() => this.page() > 1);
  protected readonly hasNext = computed(() => this.page() < this.totalPages());

  protected readonly rangeLabel = computed(() => {
    const start = (this.page() - 1) * this.pageSize() + 1;
    const end = Math.min(this.page() * this.pageSize(), this.totalItems());
    return `${start}–${end} sur ${this.totalItems()}`;
  });

  protected goTo(page: number): void {
    if (page < 1 || page > this.totalPages() || page === this.page()) {
      return;
    }
    this.pageChange.emit(page);
  }
}
